/** Серии графика без скрытых пользователем, в исходном порядке */
export function visibleSeries<T extends { dataKey: string }>(series: T[], hidden: ReadonlySet<string>): T[] {
    return series.filter((s) => !hidden.has(s.dataKey));
}

/** Новый набор скрытых серий: ключ скрывается или снова показывается */
export function toggleKey(hidden: ReadonlySet<string>, key: string): ReadonlySet<string> {
    const next = new Set(hidden);
    if (!next.delete(key)) {
        next.add(key);
    }
    return next;
}
